import * as React from 'react';
import { useSelector } from 'react-redux';
import { beatWaveListSelector } from '../../wave/selectors/wave.selectors';
import { WaveTag } from './WaveTag';

export const WaveTags: React.FC = () => {
  const waves = useSelector(beatWaveListSelector);

  return (
    <>
      {waves.map((wave) => (
        <WaveTag key={wave.id} wave={wave} />
      ))}
    </>
  );
};
